import { render, staticRenderFns } from "./ReviewOrderImportResume.vue?vue&type=template&id=05be80ee"
import script from "./ReviewOrderImportResume.vue?vue&type=script&lang=js"
export * from "./ReviewOrderImportResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports